import React from "react";
import { Alert, List } from "antd";
import { ModalItem } from "../../../../../Components/Items";

const ModalValidacionMapa = ({ visible, onClose, datos }) => {
  return (
    <ModalItem title="Validación del mapa" visible={visible} onCancel={onClose} onOk={onClose} width={520} footer={null} spinning={false}>
      {datos && (
        <>
          {datos.valido ? (
            <Alert type="success" showIcon message="El mapa no tiene problemas detectados" />
          ) : (
            <>
              {!datos.nodoInicioOk && (
                <Alert
                  style={{ marginBottom: 12 }}
                  type="error"
                  showIcon
                  message="El mapa no tiene un nodo de inicio de picking válido"
                  description='Define uno con el botón "Definir inicio" de la barra - sin esto, generar rutas usa el modo simple sin avisar, en vez de la ruta real por el grafo.'
                />
              )}
              {!datos.nodoFinOk && (
                <Alert
                  style={{ marginBottom: 12 }}
                  type="warning"
                  showIcon
                  message="El nodo de fin de picking configurado ya no existe o está bloqueado"
                  description='Vuelve a definirlo con el botón "Definir fin" de la barra, o déjalo sin definir (es opcional).'
                />
              )}
              {datos.nodosAislados.length > 0 && (
                <Alert
                  style={{ marginBottom: 12 }}
                  type="warning"
                  showIcon
                  message={`${datos.nodosAislados.length} nodo(s) sin ninguna conexión`}
                  description={<List size="small" dataSource={datos.nodosAislados} renderItem={(n) => <List.Item>{n.codigo}</List.Item>} />}
                />
              )}
              {datos.seccionesSinNodos.length > 0 && (
                <Alert
                  style={{ marginBottom: 12 }}
                  type="warning"
                  showIcon
                  message={`${datos.seccionesSinNodos.length} sección(es) sin ningún nodo`}
                  description={<List size="small" dataSource={datos.seccionesSinNodos} renderItem={(s) => <List.Item>{s.nombre}</List.Item>} />}
                />
              )}
              {datos.ubicacionesSinNodo.length > 0 && (
                <Alert
                  type="warning"
                  showIcon
                  message={`${datos.ubicacionesSinNodo.length} ubicación(es) activa(s) sin nodo de acceso`}
                  description={<List size="small" dataSource={datos.ubicacionesSinNodo} renderItem={(u) => <List.Item>{u.clave}</List.Item>} />}
                />
              )}
            </>
          )}
        </>
      )}
    </ModalItem>
  );
};

export default ModalValidacionMapa;
